<template>
  <div class="button-row d-flex justify-content-end mt-4">
    <button class="btn btn-sm btn-danger" type="button" @click="deleteItem(vbot.id)">
      Delete Phonebot
    </button>
  </div>

  <div class="p-4">
    <Form role="form" @submit="handleUpdate">
      <!-- Tab Navigation -->
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-bs-toggle="tab" href="#general">
            Allgemein
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#sip">
            SIP-Einstellungen
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#ai">
            KI-Modelle
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#network">
            Netzwerk
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#email">
            E-Mail
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#advanced">
            Erweitert
          </a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content mt-4">
        <!-- ALLGEMEIN TAB -->
        <div id="general" class="tab-pane fade show active">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Bezeichnung
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Bezeichnung</strong>
                      Der eindeutige Name für Ihren Phonebot.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.bezeichnung" name="bezeichnung" id="bezeichnung" />
                <ErrorMessage name="bezeichnung" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Product Name
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Produktversion</strong>
                      Basic: Grundfunktionen | Advanced: Erweiterte Features
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.product_name" name="product_name" id="product_name">
                  <option value="" disabled>Select Product Name</option>
                  <option value="KI-Phone-Basic">KI-Phone-Basic</option>
                  <option value="KI-Phone-Advanced">KI-Phone-Advanced</option>
                </Field>
                <ErrorMessage name="product_name" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group input-group-static mb-4">
                <label>
                  Ansagetext
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Begrüßungstext</strong>
                      Der erste Text, den Anrufer hören.
                    </div>
                  </span>
                </label>
                <textarea class="form-control" v-model="vbot.ansagetext" name="ansagetext" id="ansagetext" rows="2"></textarea>
                <ErrorMessage name="ansagetext" class="text-danger" />
              </div>
            </div>
          </div>
          
          <!-- ✅ ENHANCED PROMPT OVERLAY SEKTION -->
          <div class="row">
            <div class="col-md-12">
              <div class="input-group input-group-static mb-4" v-if="!showPromptOverlay">
                <label>
                  Prompt
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>KI-Systemanweisung</strong>
                      Definiert das Verhalten und die Persönlichkeit der KI.
                    </div>
                  </span>
                </label>
                <textarea
                  class="form-control prompt-trigger"
                  v-model="vbot.prompt"
                  name="prompt"
                  id="prompt"
                  rows="8"
                  @click="openPromptOverlay"
                  @focus="openPromptOverlay"
                  placeholder="Klicken zum Erweitern..."
                  readonly
                  style="cursor: pointer;"
                ></textarea>
                <small class="text-muted">💡 Klicken Sie hier, um den erweiterten Editor zu öffnen</small>
                <ErrorMessage name="prompt" class="text-danger" />
              </div>

              <!-- ✅ ENHANCED VOLLBILD-OVERLAY -->
              <div v-if="showPromptOverlay" class="prompt-fullscreen-overlay">
                <div class="prompt-fullscreen-container">
                  <!-- Header -->
                  <div class="prompt-header">
                    <h4 class="mb-0">
                      <i class="fas fa-edit me-2"></i>
                      Prompt Editor
                    </h4>
                    <div class="header-actions d-flex align-items-center">
                      <!-- ✅ AI GENERATION BUTTON -->
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-light me-2"
                        @click="toggleAiMode"
                        :title="showAiMode ? 'Einzelansicht' : 'KI-Assistent aktivieren'"
                      >
                        <i :class="showAiMode ? 'fas fa-columns' : 'fas fa-magic'"></i>
                      </button>
                      
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-light me-2"
                        @click="closePromptOverlay"
                        title="Minimieren"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-light"
                        @click="closePromptOverlay"
                        title="Schließen"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>

                  <!-- ✅ ENHANCED CONTENT -->
                  <div class="prompt-content">
                    <!-- ✅ SINGLE VIEW (Normal) -->
                    <div v-if="!showAiMode" class="single-view">
                      <textarea
                        class="form-control prompt-fullscreen-textarea"
                        v-model="vbot.prompt"
                        name="prompt"
                        ref="fullscreenPrompt"
                        placeholder="Geben Sie hier Ihren Prompt ein..."
                      ></textarea>
                    </div>

                    <!-- ✅ DUAL VIEW (AI-Modus) -->
                    <div v-else class="dual-view">
                      <div class="row h-100">
                        <!-- Original Prompt (Links) -->
                        <div class="col-md-6 prompt-column">
                          <div class="prompt-section h-100">
                            <h6 class="prompt-section-title">
                              <i class="fas fa-edit me-2"></i>
                              Prompt
                            </h6>
                            <textarea
                              class="form-control prompt-section-textarea"
                              v-model="vbot.prompt"
                              name="original_prompt"
                              placeholder="Geben Sie hier Ihren Prompt ein..."
                            ></textarea>
                          </div>
                        </div>

                        <!-- Generierter Prompt (Rechts) -->
                        <div class="col-md-6 prompt-column">
                          <div class="prompt-section h-100">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <h6 class="prompt-section-title mb-0">
                                <i class="fas fa-robot me-2 text-primary"></i>
                                Generierter Prompt
                              </h6>
                              <!-- ✅ Generate Button -->
                              <button 
                                type="button" 
                                class="btn btn-sm btn-primary"
                                @click="generatePrompt"
                                :disabled="isGenerating"
                                title="Prompt generieren"
                              >
                                <i :class="isGenerating ? 'fas fa-spinner fa-spin' : 'fas fa-wand-magic-sparkles'"></i>
                                {{ isGenerating ? 'Generiert...' : 'Generieren' }}
                              </button>
                            </div>
                            <textarea
                              class="form-control prompt-section-textarea generated-prompt"
                              v-model="generatedPrompt"
                              name="generated_prompt"
                              placeholder="Hier erscheint der generierte Prompt..."
                              readonly
                            ></textarea>
                            
                            <!-- ✅ Copy/Apply Buttons -->
                            <div class="mt-2 d-flex gap-2" v-if="generatedPrompt">
                              <button 
                                type="button" 
                                class="btn btn-sm btn-outline-secondary"
                                @click="copyGeneratedPrompt"
                                title="Generierten Prompt kopieren"
                              >
                                <i class="fas fa-copy me-1"></i>
                                Kopieren
                              </button>
                              <button 
                                type="button" 
                                class="btn btn-sm btn-success"
                                @click="applyGeneratedPrompt"
                                title="Generierten Prompt übernehmen"
                              >
                                <i class="fas fa-arrow-left me-1"></i>
                                Übernehmen
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Footer -->
                  <div class="prompt-footer">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="text-muted small">
                        <span v-if="!showAiMode">
                          Zeichen: {{ (vbot.prompt || '').length }} | ESC zum Schließen
                        </span>
                        <span v-else>
                          Original: {{ (vbot.prompt || '').length }} Zeichen | 
                          Generiert: {{ (generatedPrompt || '').length }} Zeichen | 
                          ESC zum Schließen
                        </span>
                      </div>
                      <div>
                        <button 
                          type="button" 
                          class="btn btn-outline-secondary me-2"
                          @click="closePromptOverlay"
                        >
                          Schließen
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-success"
                          @click="saveAndClose"
                        >
                          <i class="fas fa-save me-1"></i>
                          Fertig
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Backdrop -->
              <div 
                v-if="showPromptOverlay" 
                class="prompt-backdrop"
                @click="closePromptOverlay"
              ></div>
            </div>
          </div>
        </div>

        <!-- SIP TAB -->
        <div id="sip" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Benutzername
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SIP-Authentifizierung</strong>
                      Benutzername vom VoIP-Provider.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_benutzername" name="sip_benutzername" id="sip_benutzername" />
                <ErrorMessage name="sip_benutzername" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Password
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SIP-Passwort</strong>
                      Wird verschlüsselt gespeichert.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_passwd" name="sip_passwd" id="sip_passwd" />
                <ErrorMessage name="sip_passwd" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Registername
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Registrierungsname</strong>
                      Optional, falls vom Provider gefordert.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_registername" name="sip_registername" id="sip_registername" />
                <ErrorMessage name="sip_registername" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Telefonnummer
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Rufnummer</strong>
                      Deutschland: 0123456789
                      International nicht unterstützt.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_phonenumber" name="sip_phonenumber" id="sip_phonenumber" />
                <ErrorMessage name="sip_phonenumber" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Server-Adresse</strong>
                      Domain oder IP des Providers.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_server" name="sip_server" id="sip_server" />
                <ErrorMessage name="sip_server" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Port
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Port-Nummer</strong>
                      Standard: 5060 oder 5061 (TLS).
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_port" name="sip_port" id="sip_port" />
                <ErrorMessage name="sip_port" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Registrierungsintervall (Sekunden)
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Registrierungsintervall</strong>
                      Zeitspanne, nach der sich der SIP-Client automatisch neu beim Server anmeldet, um die Verbindung aktiv zu halten.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_registrierungsinterval"
                  name="sip_registrierungsinterval"
                  id="sip_registrierungsinterval"
                />
                <ErrorMessage name="sip_registrierungsinterval" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Domain
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SIP Domain</strong>
                      Einstellung für Innovaphone. Wird an den Phonebot übermittelt und legt die SIP-Domain fest, gegen die sich der Client registriert.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.sip_domain" name="sip_domain" id="sip_domain" />
                <ErrorMessage name="sip_domain" class="text-danger" />
              </div>
            </div>
          </div>
        </div>

        

        <!-- KI-MODELLE TAB -->
        <div id="ai" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Chatmodel
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>KI-Sprachmodell</strong>
                      GPT-4o: Beste Qualität | gpt-4o-mini: Ausgewogen
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.chatmodel" name="chatmodel" id="chatmodel">
                  <!-- Realtime-Modelle (ohne Mini): nur vom Superadmin einstellbar - werden hier angezeigt, sind aber nicht auswählbar -->
                  <option value="gpt-realtime-1.5" disabled>gpt-realtime-1.5</option>
                  <option value="gpt-4o">gpt-4o</option>
                  <option value="gpt-realtime-mini">gpt-realtime-mini</option>
                  <option value="gpt-realtime-2.1-mini">gpt-realtime-2.1-mini</option>
                  <option value="gpt-4o-mini">gpt-4o-mini</option>
                  <option value="gpt-realtime" disabled>gpt-realtime</option>
                  <option value="gpt-realtime-2" disabled>gpt-realtime-2</option>
                  <option value="gpt-realtime-2.1" disabled>gpt-realtime-2.1</option>
                  <option value="gpt-4">gpt-4</option>
                  <option value="gpt-5-mini">gpt-5-mini</option>
                  <option value="gpt-4-turbo">gpt-4-turbo</option>
                  <!-- Diese Option wird bisher nicht im Phonebot umgesetzt und wurde deshalb auskommentiert. -->
                  <!-- <option value="mistral-mistral-small">mistral-mistral-small</option> -->
                  <!-- <option value="mistral-mistral-large">mistral-mistral-large</option> -->
                </Field>
                <ErrorMessage name="chatmodel" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Voice für OpenAI
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Stimmprofil</strong>
                      Stimme für Sprachausgabe.
                      Männliche Stimmen: Ash, Echo, Ballad, Verse
                      Weibliche Stimmen: Shimmer, Sage, Coral
                      Realtime-Stimmen (von OpenAI empfohlen): Marin, Cedar
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.voice" name="voice" id="voice">
                  <option value="shimmer">Shimmer</option>
                  <option value="ash">Ash</option>
                  <option value="echo">Echo</option>
                  <option value="ballad">Ballad</option>
                  <option value="verse">Verse</option>
                  <option value="sage">Sage</option>
                  <option value="coral">Coral</option>
                  <option value="marin">Marin</option>
                  <option value="cedar">Cedar</option>
                </Field>
                <ErrorMessage name="voice" class="text-danger" />
              </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  STT Model
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Speech-to-Text</strong>
                      Spracherkennung: Sprache → Text
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.sttmodel" name="sttmodel" id="sttmodel">
                  <option value="">Select sttmodel</option>
                  <option value="OpenAI" disabled>OpenAI</option>
                  <option value="Microsoft">Microsoft</option>
                  <!-- Diese Option wird bisher nicht im Phonebot umgesetzt und wurde deshalb auskommentiert. -->
                  <!-- <option value="mistral-voxtral-mini">mistral-voxtral-mini</option> -->
                </Field>
                <ErrorMessage name="sttmodel" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TTS Model
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Text-to-Speech</strong>
                      Sprachsynthese: Text → Sprache
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.ttsmodel" name="ttsmodel" id="ttsmodel">
                  <option value="">Select ttsmodel</option>
                  <option value="OpenAI" disabled>OpenAI</option>
                  <option value="Microsoft">Microsoft</option>
                  <!-- Diese Option wird bisher nicht im Phonebot umgesetzt und wurde deshalb auskommentiert. -->
                  <!-- <option value="mistral-voxtral-tts">mistral-voxtral-tts</option> -->
                </Field>
                <ErrorMessage name="ttsmodel" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Temperatur
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>KI-Kreativität</strong>
                      0.1-0.3: Konsistent | 0.5-0.8: Ausgewogen | 1.0+: Kreativ<br>
                      <strong>Bereich:</strong> Realtime: 0.6-1.2 | Standard: 0.0-2.0
                    </div>
                  </span>
                </label>
                <Field
                  type="number"
                  class="form-control"
                  v-model="vbot.temperature"
                  name="temperature"
                  id="temperature"
                  :min="temperatureMin"
                  :max="temperatureMax"
                  :step="0.1"
                />
                <small class="form-text text-muted">
                  Erlaubter Bereich: {{ temperatureMin }} - {{ temperatureMax }}
                </small>
                <ErrorMessage name="temperature" class="text-danger" />
              </div>
            </div>
          </div>
          <!-- Allow Interruption (Admin und Adminuser, wie updateAdminFields im VbotController). Feldname bei AI-Phone: AllowInterruption, Standard an -->
          <div class="row" v-if="isAdminRole">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="allow_interruption">
                  Allow Interruption
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Allow Interruption</strong>
                      Darf der Anrufer den Bot unterbrechen, während er spricht? Standard: an.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.allow_interruption" name="allow_interruption" id="allow_interruption" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="forwarding_through_openai_tool">
                  Forwarding Through OpenAI Tool
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>OpenAI Tool Forwarding</strong>
                      Weiterleitung via OpenAI Tools.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.forwarding_through_openai_tool" name="forwarding_through_openai_tool" id="forwarding_through_openai_tool" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="websearch_openai">
                  Activate Websearch in OpenAI
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Web-Suche</strong>
                      Aktiviert Web-Suche für OpenAI.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.websearch_openai" name="websearch_openai" id="websearch_openai" />
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- NETZWERK TAB -->
        <div id="network" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TransportType
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Transportprotokoll</strong>
                      UDP: Schnell | TCP: Zuverlässig | TLS: Sicher
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.transmit_type" name="transmit_type" id="transmit_type">
                  <option value="" disabled>Select TransportType</option>
                  <option value="tcp">tcp</option>
                  <option value="udp">udp</option>
                  <option value="tls">tls</option>
                  <option value="stcp">stcp</option>
                </Field>
                <ErrorMessage name="transmit_type" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  STUN Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>NAT-Traversal</strong>
                      Hilft bei Firewall-Verbindungen.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.stun_server" name="stun_server" id="stun_server" />
                <ErrorMessage name="stun_server" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TURN Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>TURN Server</strong>
                      Relay-Server für NAT-Traversal.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.turnserver" name="turnserver" id="turnserver" />
                <ErrorMessage name="turnserver" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Outbound Proxy
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Proxy-Server</strong>
                      Optional: Outbound Proxy.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.OutboundProxy" name="OutboundProxy" id="OutboundProxy" />
                <ErrorMessage name="OutboundProxy" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TURN Server Username
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>TURN Benutzername</strong>
                      Authentifizierung für TURN.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.nat_username" name="nat_username" id="nat_username" />
                <ErrorMessage name="nat_username" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TURN Server Password
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>TURN Passwort</strong>
                      Passwort für TURN-Authentifizierung.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.nat_password" name="nat_password" id="nat_password" />
                <ErrorMessage name="nat_password" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">       
            <div class="col-md-4">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="useSRTP">
                  Use SRTP
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Verschlüsselung</strong>
                      SRTP verschlüsselt Sprachdaten.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.useSRTP" name="useSRTP" id="useSRTP" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- EMAIL TAB -->
        <div id="email" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SMTP-Server</strong>
                      z.B. smtp.gmail.com
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.e_mail_server" name="e_mail_server" id="e_mail_server" />
                <ErrorMessage name="e_mail_server" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Server Port
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SMTP-Port</strong>
                      587 (TLS), 465 (SSL)
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.e_mail_server_port" name="e_mail_server_port" id="e_mail_server_port" />
                <ErrorMessage name="e_mail_server_port" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email User
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>E-Mail-Adresse</strong>
                      Login für E-Mail-Versand.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.e_mail_user" name="e_mail_user" id="e_mail_user" />
                <ErrorMessage name="e_mail_user" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Password
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>E-Mail-Passwort</strong>
                      Passwort für den Benutzer.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.e_mail_passwd" name="e_mail_passwd" id="e_mail_passwd" />
                <ErrorMessage name="e_mail_passwd" class="text-danger" />
              </div>
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Server From
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Absender-Adresse</strong>
                      Als Absender angezeigte E-Mail.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.e_mail_server_from" name="e_mail_server_from" id="e_mail_server_from" />
                <ErrorMessage name="e_mail_server_from" class="text-danger" />
              </div>
            </div>
          </div>
          <div>
            <div class="col-md-4">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="mail_certifikate_validation">
                  Mail Certificate Validation
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Zertifikatsprüfung</strong>
                      SSL/TLS-Zertifikate validieren.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.mail_certifikate_validation" name="mail_certifikate_validation" id="mail_certifikate_validation" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ERWEITERT TAB -->
        <div id="advanced" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  PromptXT-URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Externe Prompt-Quelle</strong>
                      URL zu externer Prompt-Datei.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.prompturl" name="prompturl" id="prompturl" />
                <ErrorMessage name="prompturl" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Outbound List URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Outbound-Liste</strong>
                      URL zur Outbound-Anrufliste.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.outbound_list_url"
                  name="outbound_list_url"
                  id="outbound_list_url"
                />
                <ErrorMessage name="outbound_list_url" class="text-danger" />
              </div>
            </div>
            
          </div>
          <div class="row">
            
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Flowise URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Flowise Integration</strong>
                      URL zu Flowise-Workflow.
                    </div>
                  </span>
                </label>
                <Field type="text" class="form-control" v-model="vbot.flowiseurl" name="flowiseurl" id="flowiseurl" />
                <ErrorMessage name="flowiseurl" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  n8n URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>n8n Integration</strong>
                      Optional: URL zu Ihrem n8n-Workflow für erweiterte KI-Funktionen und Integrationen.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.n8n_url"
                  name="n8n_url"
                  id="n8n_url"
                />
                <ErrorMessage name="n8n_url" class="text-danger" />
              </div>
            </div>
          </div>  
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="attendedtransfer">
                  Attended Transfer
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Attended Transfer</strong>
                      Beaufsichtigte Anrufweiterleitung.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.attendedtransfer" name="attendedtransfer" id="attendedtransfer" />
                </div>
              </div>
            </div>
            <div class="col-md-6" v-show="vbot.attendedtransfer">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="validatetransfer">
                  Validate Transfer
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Validate Transfer</strong>
                      Aktiviert die Validierung der Anrufweiterleitung vor dem Transfer.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.validatetransfer" name="validatetransfer" id="validatetransfer" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="web_log_enabled">
                  Web-Log
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Web-Logging</strong>
                      Aktiviert Logging im Interface.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.web_log_enabled" name="web_log_enabled" id="web_log_enabled" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Time until call abort (seconds)
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Timeout</strong>
                      Sekunden bis Anruf abgebrochen wird.
                    </div>
                  </span>
                </label>
                <Field type="number" class="form-control" v-model="vbot.abort_time" name="abort_time" id="abort_time" />
                <ErrorMessage name="abort_time" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-4">
                <label class="form-label d-block">
                  Category Terms (Max 5)
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Kategorie-Begriffe</strong>
                      Bis zu 5 Begriffe zur Kategorisierung.
                    </div>
                  </span>
                </label>
                <div v-for="(term, index) in vbot.category_terms" :key="index" class="d-flex align-items-center mb-2">
                  <div class="flex-grow-1 input-group input-group-static">
                    <Field type="text" class="form-control border-0 border-bottom" v-model="vbot.category_terms[index]" :name="'category_terms_' + index" :id="'category_terms_' + index" />
                  </div>
                  <button type="button" class="btn btn-sm btn-danger ms-2" @click="deleteCategoryTerm(index)" v-if="vbot.category_terms.length > 1">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
                <ErrorMessage name="category_terms" class="text-danger" />
                <button v-if="vbot.category_terms.length < 5" type="button" class="btn btn-sm btn-primary mt-2" @click="addCategoryTerm">
                  <i class="fas fa-plus"></i> Add Term
                </button>
                <div v-else>
                  <small class="text-muted">Maximum 5 category terms allowed.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Field type="hidden" class="form-control" v-model="vbot.id" name="id" id="id" />

      <div class="button-row d-flex justify-content-end mt-4">
        <button class="btn btn-sm btn-dark">
          Update Phonebot
        </button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import showSwal from "@/mixins/showSwal";
import Swal from 'sweetalert2';
import userService from "@/services/users.service";

export default {
  name: "Info3",
  components: {
    Form,
    Field,
    ErrorMessage
  },
  data() {
    return {
      // Enhanced Overlay-Steuerung
      showPromptOverlay: false,
      showAiMode: false,
      originalPrompt: '',
      generatedPrompt: '',
      isGenerating: false,
      role: '',

      vbot: {
        mail_certifikate_validation: false,
        attendedtransfer: false,
        validatetransfer: false,
        useSRTP: false,
        category_terms: [],
        web_log_enabled: true,
        abort_time: 30,
        allow_interruption: true, // AllowInterruption bei AI-Phone (Admin und Adminuser), Standard an
      },
    };
  },
  computed: {
    // Admin-Rollen (identisch zu updateAdminFields im VbotController) - nur deren Wert für Allow Interruption übernimmt das Backend
    isAdminRole() {
      return ['admin', 'adminuser', 'super'].includes(this.role);
    },

    temperatureMin() {
      return this.vbot.chatmodel && (this.vbot.chatmodel.includes('realtime') || this.vbot.chatmodel.includes('audio')) ? 0.6 : 0;
    },
    temperatureMax() {
      return this.vbot.chatmodel && (this.vbot.chatmodel.includes('realtime') || this.vbot.chatmodel.includes('audio')) ? 1.2 : 2;
    }
  },
  methods: {
    // Benutzerrolle laden (steuert Sichtbarkeit der rollenabhängigen Felder)
    async fetchRole() {
      try {
        const response = await userService.fetchRole();
        this.role = response.role;
      } catch (error) {
        console.error("Error fetching user role:", error);
      }
    },

    // Enhanced Prompt Overlay Methoden
    openPromptOverlay() {
      this.originalPrompt = this.vbot.prompt;
      this.showPromptOverlay = true;
      this.showAiMode = false;
      this.$nextTick(() => {
        this.$refs.fullscreenPrompt?.focus();
        document.body.style.overflow = 'hidden';
      });
    },

    closePromptOverlay() {
      this.showPromptOverlay = false;
      this.showAiMode = false;
      document.body.style.overflow = '';
    },

    saveAndClose() {
      this.closePromptOverlay();
    },

    handleEscape(event) {
      if (event.key === 'Escape' && this.showPromptOverlay) {
        this.closePromptOverlay();
      }
    },

    // AI-Modus Methoden
    toggleAiMode() {
      this.showAiMode = !this.showAiMode;
      if (this.showAiMode && !this.generatedPrompt) {
        this.generatedPrompt = '';
      }
    },

    async generatePrompt() {
      // ✅ FALLBACK: Verwende license_Key wenn id fehlt
      let vbotId = this.vbot.id;
      
      if (!vbotId) {
        console.warn('⚠️ VBot ID fehlt, verwende license_Key als Fallback');
        vbotId = this.vbot.license_Key || this.$route.params.license_Key;
      }

      if (!vbotId) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Fehler: VBot-ID nicht verfügbar. Bitte laden Sie die Seite neu.",
          width: 500,
          timer: 4000
        });
        return;
      }

      this.isGenerating = true;
      
      try {
        const promptData = {
          current_prompt: this.vbot.prompt || ''
        };

        const response = await this.$store.dispatch('vbot/generatePrompt', {
          vbotId: vbotId,
          promptData: promptData
        });

        this.generatedPrompt = response.generated_prompt;
        
        showSwal.methods.showSwal({
          type: "success",
          message: "Prompt erfolgreich generiert!",
          width: 400,
          timer: 2000
        });
        
      } catch (error) {
        console.error('❌ Prompt generation error:', error);
        
        let errorMessage = "Fehler bei der Prompt-Generierung";
        if (error.response?.status === 404) {
          errorMessage = `API-Route nicht gefunden. VBot-ID: ${vbotId}`;
        } else if (error.response?.data?.error) {
          errorMessage = error.response.data.error;
        }
        
        showSwal.methods.showSwal({
          type: "error",
          message: errorMessage,
          width: 500,
          timer: 5000
        });
      } finally {
        this.isGenerating = false;
      }
    },

    copyGeneratedPrompt() {
      if (navigator.clipboard && this.generatedPrompt) {
        navigator.clipboard.writeText(this.generatedPrompt).then(() => {
          showSwal.methods.showSwal({
            type: "success",
            message: "Generierter Prompt kopiert!",
            width: 400,
            timer: 2000
          });
        });
      }
    },

    async applyGeneratedPrompt() {
      if (this.generatedPrompt) {
        const result = await Swal.fire({
          title: 'Prompt übernehmen?',
          html: `
            <div class="text-start">
              <p class="mb-3"><strong>Sie sind dabei, den generierten Prompt zu übernehmen.</strong></p>
              <div class="alert alert-warning text-start mb-0">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Der Prompt wird erst <strong>nach dem Klick auf "Update Phonebot"</strong> 
                endgültig gespeichert.
              </div>
            </div>
          `,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Ja, übernehmen',
          cancelButtonText: 'Abbrechen',
        });

        if (result.isConfirmed) {
          this.vbot.prompt = this.generatedPrompt;
          showSwal.methods.showSwal({
            type: "success",
            message: "Prompt übernommen!",
            width: 450,
            timer: 4000
          });
        }
      }
    },

    // Ursprüngliche Methoden
    async handleUpdate() {
      try {
        const payload = {
          ...this.vbot,
          attendedtransfer: Boolean(this.vbot.attendedtransfer),
          validatetransfer: Boolean(this.vbot.validatetransfer),
        };
        await this.$store.dispatch('vbot/updateVbot', payload);
        showSwal.methods.showSwal({
          type: "success",
          message: "Phonebot Updated Successfully",
          width: 500,
          timer: 160000,
          showConfirmButton: true
        });
        this.$router.push({ name: 'vbots' });
      } catch (error) {
        console.error('Phonebot error:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Error In Updating Phonebot!",
          width: 500
        });
      }
    },

    async deleteItem(vid) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
      });

      if (result.isConfirmed) {
        try {
          await this.$store.dispatch('vbot/deleteVbot', vid);
          Swal.fire('Deleted!', 'Phonebot has been deleted.', 'success');
          this.$router.push({ name: 'vbots' });
        } catch (error) {
          console.error(`Error deleting phonebot with ID: ${vid}`, error);
          Swal.fire('Error!', 'There was an error deleting the phonebot. Please try again.', 'error');
        }
      }
    },

    addCategoryTerm() {
      if (this.vbot.category_terms.length < 5) {
        this.vbot.category_terms.push("");
      }
    },

    deleteCategoryTerm(index) {
      if (this.vbot.category_terms.length > 1) {
        this.vbot.category_terms.splice(index, 1);
      }
    },
  },

  async mounted() {
    // Event Listener für ESC-Taste
    document.addEventListener('keydown', this.handleEscape);

    this.fetchRole();

    const licenseKey = this.$route.params.license_Key;
    try {
      const vbots = await this.$store.dispatch('vbot/getVbotById', licenseKey);
      this.vbot = {
        ...vbots,
        mail_certifikate_validation: vbots.mail_certifikate_validation === "1" || vbots.mail_certifikate_validation === 1,
        attendedtransfer: vbots.attendedtransfer === true || vbots.attendedtransfer === "1" || vbots.attendedtransfer === 1,
        validatetransfer: vbots.validatetransfer === true || vbots.validatetransfer === "1" || vbots.validatetransfer === 1,
        useSRTP: vbots.useSRTP === "1" || vbots.useSRTP === 1,
        web_log_enabled: vbots.web_log_enabled === "1" || vbots.web_log_enabled === 1,
        forwarding_through_openai_tool: vbots.forwarding_through_openai_tool === "1" || vbots.forwarding_through_openai_tool === 1,
        websearch_openai: vbots.websearch_openai === "1" || vbots.websearch_openai === 1,
        // Haken gesetzt, solange nicht ausdrücklich false gespeichert ist (wie in Info4.vue)
        allow_interruption: ![false, 0, "0"].includes(vbots.allow_interruption),
        category_terms: Array.isArray(vbots.category_terms) ? vbots.category_terms : [],
        voice: vbots.voice ? vbots.voice.toLowerCase() : null
      };
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscape);
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
/* Weiße Hintergrund für alle Input-Felder */
.form-control {
  background-color: #ffffff !important;
}

/* Weiße Hintergrund für Textareas */
textarea.form-control {
  background-color: #ffffff !important;
}

/* Weiße Hintergrund für Select-Felder */
select.form-control {
  background-color: #ffffff !important;
}

/* Weiße Hintergrund für den gesamten Tab-Content-Bereich */
.tab-content {
  background-color: #ffffff;
}

.tab-pane {
  background-color: #ffffff;
}

.input-group-static label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #17a2b8;
  color: white;
  font-size: 11px;
  font-weight: bold;
  cursor: help;
  position: relative;
  transition: all 0.3s;
}

.info-icon:hover {
  background: #138496;
  transform: scale(1.1);
}

.info-tooltip {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background: #2c3e50;
  color: white;
  padding: 10px 15px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: normal;
  white-space: normal;
  width: 250px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  line-height: 1.4;
}

.info-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #2c3e50;
}

.info-icon:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
  bottom: 135%;
}

.info-tooltip strong {
  display: block;
  margin-bottom: 5px;
  color: #3498db;
}

.nav-tabs .nav-link {
  color: #495057;
}

.nav-tabs .nav-link.active {
  font-weight: 600;
}

/* ✅ ENHANCED PROMPT EDITOR STYLES */

/* Prompt Trigger Styles */
.prompt-trigger {
  transition: all 0.3s ease;
  border: 2px dashed #dee2e6 !important;
}

.prompt-trigger:hover {
  background-color: #f8f9fa !important;
  border-color: #007bff !important;
  transform: scale(1.01);
}

.prompt-trigger:focus {
  background-color: #f8f9fa !important;
  border-color: #007bff !important;
}

/* ✅ SICHERSTELLUNG DASS SWEETALERT2 ÜBER PROMPT-OVERLAY ERSCHEINT */
:deep(.swal-high-z-index) {
  z-index: 10001 !important;
}

/* ✅ GLOBAL SWEETALERT2 Z-INDEX FIX */
:global(.swal2-container) {
  z-index: 10001 !important;
}

:global(.swal2-backdrop-show) {
  z-index: 10001 !important;
}

/* Backdrop - absolut im Vordergrund */
.prompt-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  backdrop-filter: blur(3px);
}

/* Hauptcontainer - über allem */
.prompt-fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

/* Editor Container */
.prompt-fullscreen-container {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 1400px; /* Breiter für Dual-View */
  height: 85vh;
  max-height: 900px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
  animation: slideInScale 0.4s ease;
  overflow: hidden;
}

/* Header */
.prompt-header {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.prompt-header .header-actions {
  gap: 8px;
}

/* Content Bereich */
.prompt-content {
  flex: 1;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Single View (Normal) */
.single-view {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Dual View (AI-Modus) */
.dual-view {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dual-view .row {
  flex: 1;
  margin: 0;
}

.prompt-column {
  padding: 0 10px;
  height: 100%;
}

.prompt-column:first-child {
  border-right: 2px solid #e9ecef;
  padding-right: 15px;
}

.prompt-column:last-child {
  padding-left: 15px;
}

/* Prompt Sections */
.prompt-section {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.prompt-section-title {
  color: #495057;
  font-weight: 600;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}

.prompt-section-textarea {
  flex: 1;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  resize: none;
  outline: none;
  transition: border-color 0.3s ease;
  min-height: 300px;
}

.prompt-section-textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

/* Generated Prompt Specific */
.generated-prompt {
  background-color: #f8f9fa !important;
  border-color: #28a745 !important;
}

.generated-prompt:focus {
  border-color: #28a745 !important;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1) !important;
}

/* Regular Textarea (Single View) */
.prompt-fullscreen-textarea {
  flex: 1;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  resize: none;
  outline: none;
  transition: border-color 0.3s ease;
}

.prompt-fullscreen-textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

/* Footer */
.prompt-footer {
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

/* Animationen */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideInScale {
  from { 
    opacity: 0;
    transform: scale(0.9) translateY(-30px);
  }
  to { 
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .prompt-fullscreen-overlay {
    padding: 10px;
  }
  
  .prompt-fullscreen-container {
    height: 95vh;
    max-height: none;
    max-width: none;
  }
  
  .prompt-header {
    padding: 12px 15px;
  }
  
  .prompt-content {
    padding: 15px;
  }
  
  .prompt-footer {
    padding: 12px 15px;
  }
  
  /* Mobile: Stack columns vertically */
  .dual-view .prompt-column {
    padding: 0;
  }
  
  .dual-view .prompt-column:first-child {
    border-right: none;
    border-bottom: 2px solid #e9ecef;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  
  .dual-view .prompt-column:last-child {
    padding-left: 0;
  }
}

/* Scrollbar für Textarea */
.prompt-fullscreen-textarea::-webkit-scrollbar,
.prompt-section-textarea::-webkit-scrollbar {
  width: 8px;
}

.prompt-fullscreen-textarea::-webkit-scrollbar-track,
.prompt-section-textarea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.prompt-fullscreen-textarea::-webkit-scrollbar-thumb,
.prompt-section-textarea::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.prompt-fullscreen-textarea::-webkit-scrollbar-thumb:hover,
.prompt-section-textarea::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* ✅ CUSTOM MODAL STYLES */
:global(.apply-prompt-modal) {
  border-radius: 12px !important;
}

:global(.apply-prompt-modal .swal2-html-container) {
  margin: 0 !important;
  padding: 0 !important;
}

:global(.apply-prompt-modal .alert) {
  border-radius: 8px;
  font-size: 0.9rem;
}

:global(.apply-prompt-modal .swal2-actions) {
  gap: 10px;
}

:global(.apply-prompt-modal .swal2-confirm) {
  padding: 10px 20px !important;
  font-weight: 500 !important;
}

:global(.apply-prompt-modal .swal2-cancel) {
  padding: 10px 20px !important;
  font-weight: 500 !important;
}
</style>